export const IS_FETCHING = "is_fetching";
export const IS_NOT_FETCHING = "is_not_fetching";
